import { createSelector, createSlice } from '@reduxjs/toolkit';
import qs from 'qs';
import * as R from 'ramda';
import http from 'utils/http';
import { createSnack } from 'snackbar/snackbarSlice';

const initialState = {
  error: '',
  originatorLocationsList: [],
  pending: false,
};

const reducers = {
  fetchOriginatorLocationsError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  fetchOriginatorLocationsPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  fetchOriginatorLocationsSuccess(state, { payload }) {
    const list = payload ?? [];
    return R.assoc('originatorLocationsList', list, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'originatorLocations',
  reducers,
});

const {
  fetchOriginatorLocationsPending,
  fetchOriginatorLocationsSuccess,
  fetchOriginatorLocationsError,
} = actions;

// Selectors
const originatorLocationsSelector = state => state.pto.originatorLocations.originatorLocationsList;

export const getOriginatorLocationsOptions = createSelector(originatorLocationsSelector, options =>
  options.map(location => ({
    label: location.locationNameLong,
    value: location.locationId,
  }))
);

// Actions
let fetchController;
export function fetchOriginatorLocations(params = {}) {
  if (fetchController) fetchController.abort();
  fetchController = new AbortController();
  const { signal } = fetchController;
  return dispatch => {
    dispatch(fetchOriginatorLocationsPending(true));
    const formattedParams = qs.stringify(params, {
      allowDots: true,
      encode: false,
    });

    return http
      .get(`/product-transfer-orders/get-unique-originator-locations?${formattedParams}`, {
        signal,
      })
      .then(res => {
        dispatch(fetchOriginatorLocationsError(''));
        dispatch(fetchOriginatorLocationsSuccess(res.data));
        dispatch(fetchOriginatorLocationsPending(false));
      })
      .catch(error => {
        if (error?.response?.data?.title) {
          dispatch(
            createSnack({
              message: error.response.data.title,
              options: { variant: 'error' },
            })
          );
        }
      });
  };
}

export default reducer;
